var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-sort';
                    var viewUrl = 'sprite.svg#view-icon-sort';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 26 17',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };